<!-- =========================================================================================
    File Name: Utenti.vue
    Description: Tabella degli utenti
    ----------------------------------------------------------------------------------------
    Item Name:
      Author:
    Author URL:
========================================================================================== -->


<template>
    <div id="pagina-utenti">
        <!-- {{$acl.check('admin')}} -->
        <table-utenti></table-utenti>
    </div>
</template>

<script>

import TableUtenti from './TableUtenti.vue'

export default{
    components: {
        TableUtenti,
    }
}
</script>
